module.exports = __webpack_public_path__ + "static/media/lelle.aeaf6c9d.jpeg";